<template lang="pug">
#footer-box 2024
</template>

<script>
export default {
    name: 'FooterComponent',
};
</script>

<style>
#footer-box {
    font-family: 'Roboto 400';
    display: flex;
    justify-items: center;
    align-content: center;
    align-items: center;
    flex-direction: row;
    justify-content: center;

    background-color: var(--primary-light-smoke);

    color: var(--primary-white);
    font-size: 10px;
    padding: 5px 0 5px 0;

    bottom: 0;
    left: 0;
    height: 20px;
    position: fixed;
    width: 100%;

    bottom: 0;
    left: 0;
    height: 20px;
    position: fixed;
    width: 100%;
}
</style>
